













import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class KDialog extends Vue {
  @Prop({default: false, type: Boolean}) open

  visibleHeader: boolean = false
  visibleFooter: boolean = false

  updated() {
    this.visibleHeader = Boolean(this.$slots.header)
    this.visibleFooter = Boolean(this.$slots.footer)
  }

  mounted() {
    this.visibleHeader = Boolean(this.$slots.header)
    this.visibleFooter = Boolean(this.$slots.footer)
  }
}
